import { get, post } from "./utils";


// GET NEW
export const getLMSInfo = () => {
  return get(`/api/v1/lms`);
};
export const getLCMSInfo = () => {
  return get(`/api/v1/lcms`);
};
export const getStudentOnlineRate = () => {
  return get(`/api/v1/student-participation`);
};
export const getInteractiveLessionRate = () => {
  return get(`/api/v1/teacher-interactive`);
};
export const getAssessmentTracking = () => {
  return get(`/api/v1/assessment`);
};


// CREATE JOB NEW
export const createJobLMSInfo = () => {
  return post(`/api/v1/lms/scheduler`);
};
export const createJobLCMSInfo = () => {
  return post(`/api/v1/lcms/scheduler`);
};
export const createJobStudentOnlineRate = () => {
  return post(`/api/v1/student-participation/scheduler`);
};
export const createJobInteractiveLessionRate = () => {
  return post(`/api/v1/teacher-interactive/scheduler`);
};
export const createJobAssessmentTracking = () => {
  return post(`/api/v1/assessment/scheduler`);
};


// GET JOB NEW
export const getJobLMSInfo = () => {
  return get(`/api/v1/lms/scheduler`);
};
export const getJobLCMSInfo = () => {
  return get(`/api/v1/lcms/scheduler`);
};
export const getJobStudentOnlineRate = () => {
  return get(`/api/v1/student-participation/scheduler`);
};
export const getJobInteractiveLessionRate = () => {
  return get(`/api/v1/teacher-interactive/scheduler`);
};
export const getJobAssessmentTracking = () => {
  return get(`/api/v1/assessment/scheduler`);
};
export const getContentsRate = () => {
  return get(`/api/v1/contents`);
};
export const createJobContentsRate = () => {
  return post(`/api/v1/contents/scheduler`);
};
export const getJobContentsRate = () => {
  return get(`/api/v1/contents/scheduler`);
};
export const exportStudentParticipationRate = () => {
  return `/api/v1/student-participation/export`;
};

export const exportAssessmentTracking = () => {
  return `/api/v1/assessment/export`;
};

export const getDtiContext = () => get(`/api/v1/context`);

export const submitDtiMetric = (metricId) => post(`/api/v1/${metricId}`);

export const submitLMSInfo = () => submitDtiMetric('lms');
export const submitLessonInfo = () => submitDtiMetric('teacher-interactive');
